import { PAGEPATHS } from "components/Common/Constant"
import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"

import { connect } from "react-redux";

import { setBreadcrumbItems } from "../../store/actions";
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import "./analytics.css"

const Analytics = (props) => {
    document.title = "Analytics";
    const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const [phttData, setPshttData] = useState({})
    const [sslyzeData, setSslyzeData] = useState({})
    const [participatesInAnalytics, setParticipatesInAnalytics] = useState(false)
    const [govAnalytics, setGovAnalytics] = useState(false)
    const [dapData, setDapData] = useState({
        dapDetected: '',
        dapParameters: ''
    })

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Analytics", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems('Analytics', breadcrumbItems)
    })

    const fetchAnalyticsScans = async () => {
        try {
            const { data } = await axiosInstance.get(`${ApiNames.FETCH_ANALYTICS_SCAN}/${scanId}`)
            if (data.status)
                setParticipatesInAnalytics(data.data['Participates in Analytics'])
        } catch (e) {
            console.error(e);
        }
    }

    const fetchGovAnalyticsScans = async () => {
        try {
            const { data } = await axiosInstance.get(`${ApiNames.FETCH_GOV_ANALYTICS_SCAN}/${scanId}`)
            if (data.status)
                setGovAnalytics(data.data)
        } catch (e) {
            console.error(e);
        }
    }

    const fetchDapData = async () => {
        const { data } = await axiosInstance.get(`${ApiNames.FETCH_DAP_SCAN}/${scanId}`)
        if (data.status)
            setDapData({
                dapDetected: data.data.dap_detected,
                dapParameters: data.data.dap_parameters
            })
    }

    useEffect(() => {
        if (scanId) {
            fetchAnalyticsScans()
            fetchGovAnalyticsScans()
            fetchDapData()
        }
    }, [scanId])

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card 
                        className="flex-col md:flex-row"
                        style={{
                            gap: '0 1em',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'start',
                            padding: "30px 30px 0",
                            flexWrap: 'wrap'
                        }}>
                        <Card 
                            className="w-full md:w-[48%]"
                            style={{
                                display: 'flex',
                                // height: '11em',
                                backgroundColor: participatesInAnalytics ? 'rgb(202, 254, 206)' : 'rgb(254, 202, 202)'
                            }}>
                            <TableHeader
                                customStyle={{ backgroundColor: '#f8f8f9' }}
                                scanName={'Participates in Analytics'}
                                scanId={null}
                            />
                            <span
                                style={{
                                    fontSize: '1.5em',
                                    fontWeight: '700',
                                    padding: '1.25rem',
                                    textAlign: 'center',
                                    color: participatesInAnalytics ? '#00a70b' : '#a70000'
                                }}
                            >
                                {participatesInAnalytics.toString()}
                            </span>
                        </Card>
                        <Card className="w-full md:w-[48%]">
                            <TableHeader scanName={'Dap Detected'} scanId={null} />
                            <CardBody
                                style={{
                                    backgroundColor: dapData.dapDetected ? 'rgb(202, 254, 206)' : 'rgb(254, 202, 202)',
                                    textAlign: 'center'
                                }}
                            >
                                <span
                                    style={{
                                        color: dapData.dapDetected ? '#00a70b' : '#a70000',
                                        fontSize: '1.5em',
                                        fontWeight: '700'
                                    }}>
                                    {dapData.dapDetected.toString()}
                                </span>
                            </CardBody>
                        </Card>

                        <Card className="w-full md:w-[48%]" >
                            <TableHeader scanName={'Dap Parameters Detected'} scanId={null} />
                            <CardBody
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    maxHeight: '30em',
                                    overflow: 'auto',
                                    textAlign: 'center'
                                }}
                            >
                                <span style={{ fontSize: '18px', fontWeight: '700' }}>{dapData.dapParameters}</span>
                            </CardBody>
                        </Card>
                    </Card>
                </Col>
                <Col>
                    <Card style={{ margin: '3em 0' }}>
                        <TableHeader scanName={'Gov Analytics report'} scanId={null} />
                        <CardBody
                            style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <div>
                                <p style={{ fontSize: '18px' }}><strong>Domain Visits (Past 30 days):</strong> {govAnalytics['Domain Visits (Past 30 days)']}</p>
                                <p style={{ fontSize: '18px' }}><strong>Page Views (Past 30 days):</strong> {govAnalytics['Page Views (Past 30 days)']}</p>
                            </div>
                            <strong style={{ fontSize: '18px' }}>Top Downloads</strong>
                            <ul style={{ listStyle: "none", padding: 0 }}>
                                {govAnalytics['Top Downloads'] && govAnalytics['Top Downloads'].length > 0 && govAnalytics['Top Downloads'].map((item, index) => (
                                    <li key={index} style={{ display: "flex", alignItems: 'center', padding: 15, justifyContent: "space-between", border: "1px solid lightgrey", borderLeft: "5px solid #6f7bec" }}>
                                        <p className="mb-0">{item.file}</p>
                                        <strong><p className="mb-0 rounded-pill" style={{ fontSize: 15, backgroundColor: "#6f7bec20", color: "#6f7bec", padding: "5px 15px" }}>{item.hits}</p></strong>
                                    </li>
                                ))}
                            </ul>
                        </CardBody>
                    </Card></Col>
            </Row>
        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(Analytics)